import OtpForm from '@/components/OtpForm';
import { ROUTES } from '@/constants/routes';
import { useResetPassword } from '@/hooks/requests/useAuth';
import useOtpForm from '@/hooks/useOtpForm';
import { OTPFormFields } from '@/types/common';
import showToast from '@/utils/toast';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { logAnalyticsEvent } from '@/utils/analytics';
import { useAuthUser } from '@/hooks/stores/useAuthUser';

export default function ForgotPasswordOtp() {
  const navigate = useNavigate();
  const { isStaff } = useAuthUser();
  const { state } = useLocation();
  const { email } = state || {};
  const {
    startResetPassword,
    isLoadingStartResetPassword,
    resetPasswordChallengeValidation,
    isLoadingResetPasswordChallengeValidation,
  } = useResetPassword();
  const {
    formMethods,
    handleResendError,
    handleSubmitError,
    hasFailedOnce,
    setHasFailedOnce,
    submitForm,
  } = useOtpForm();

  if (!email) {
    return <Navigate to={ROUTES.FORGOT_PASSWORD} replace />;
  }

  async function handleSubmit(data: OTPFormFields) {
    setHasFailedOnce(true);
    const response = await resetPasswordChallengeValidation(
      {
        email,
        otp: data.code,
      },
      {
        onError: () => handleSubmitError(true),
      },
    );

    if (!response.success) {
      handleSubmitError();
      return;
    }

    navigate(ROUTES.FORGOT_PASSWORD_SUCCESS, {
      replace: true,
    });
  }

  async function handleResendOtp() {
    const response = await startResetPassword(
      {
        email,
        userGroup: isStaff ? 'staff' : 'teammate',
      },
      {
        onError: () => handleResendError(true),
      },
    );

    if (response !== 200) {
      logAnalyticsEvent({
        category: 'error',
        action: 'forgotPasswordError',
      });
      handleResendError();
    }

    showToast({
      type: 'success',
      data: { content: 'A new code has been sent' },
    });
  }

  return (
    <OtpForm
      hasFailedOnce={hasFailedOnce}
      formMethods={formMethods}
      isLoading={isLoadingResetPasswordChallengeValidation}
      isLoadingResend={isLoadingStartResetPassword}
      content="A verification code has been sent to your phone number. Please enter it below."
      handleResendOtp={handleResendOtp}
      handleSubmit={handleSubmit}
      submitForm={submitForm}
    />
  );
}
